import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import Raven from 'raven-js';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getAddOnsRpc } from '../../__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc';
import { fetchBundlesApiFailed, fetchEligibleAddonsCompleted, fetchEligibleAddonsStarted, planBuilderIneligibleAddonsRemoved } from '../actions/PlanBuilderActions';
import { FETCH_BUNDLES_API_COMPLETED, PLAN_BUILDER_QUANTITY_UPDATED, PLAN_BUILDER_SKU_REMOVED } from '../actions/constants/ActionTypes';
import { planBuilderProductConfigurationsSelector } from '../selectors/PlanBuilderSelectors';
import { productForSkuIdSelector, skuIdIsAddonOrServiceSelector } from '../selectors/ProductsSelectors';
import { getAddOnsFromApiNamesWithTranslations } from '../utils/addOnsUtils';
import { isValidApiName } from '../v2/utils/typeguards';
const noAuthRpcClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
const fetchEligibleAddOns = apiNames => {
  const countryCode = window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase() || 'US';
  return noAuthRpcClient.call(getAddOnsRpc, {
    request: {
      countryCode,
      productApiNames: apiNames
    }
  }).catch(error => {
    Raven.captureException(error, {
      fingerprint: ['Failed to fetch eligible add-ons'],
      extra: {
        apiNames,
        countryCode
      }
    });
    throw error;
  });
};
export const eligibleAddonsMiddleware = store => next => action => {
  if (action.type === FETCH_BUNDLES_API_COMPLETED || action.type === PLAN_BUILDER_SKU_REMOVED || action.type === PLAN_BUILDER_QUANTITY_UPDATED) {
    // Commit the previous action's payload to state so we can access
    // the updated productConfigurations below
    next(action);

    // Apply the loading state
    store.dispatch(fetchEligibleAddonsStarted());
    const state = store.getState();
    const productConfigurations = planBuilderProductConfigurationsSelector(state);
    const apiNamesToRequest = productConfigurations.map(product => {
      return productForSkuIdSelector(state, {
        skuId: product.skuId
      }).apiName;
    });
    fetchEligibleAddOns(apiNamesToRequest).then(({
      eligibleAddOns
    }) => {
      const eligibleAddOnApiNames = eligibleAddOns.filter(isValidApiName);
      const addOns = getAddOnsFromApiNamesWithTranslations(state, eligibleAddOnApiNames);
      const apiNames = addOns.filteredAddOns.map(({
        apiName
      }) => apiName);
      const skuIds = addOns.filteredAddOns.map(({
        skuId
      }) => skuId);
      store.dispatch(fetchEligibleAddonsCompleted({
        apiNames,
        skuIds
      }));
      const filteredProductConfigurations = productConfigurations.filter(({
        skuId
      }) => {
        const isAddon = skuIdIsAddonOrServiceSelector(state, {
          skuId
        });
        return !isAddon || skuIds.includes(skuId);
      });
      if (filteredProductConfigurations.length !== productConfigurations.length) {
        store.dispatch(planBuilderIneligibleAddonsRemoved({
          productConfigurations: filteredProductConfigurations
        }));
      }
    }).catch(() => {
      store.dispatch(fetchBundlesApiFailed());
    });
    return;
  }
  return next(action);
};